import Compressor from 'compressorjs';
import { toast } from 'react-toastify';

export const MB_TO_BYTE = 1000000;
export const DEFAULT_MAX_SIZE = 32000000;

export const compressImage = async (file: any) => {
  return new Promise((resolve, reject) => {
    if (file.type.startsWith('image/')) {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 1920,
        success: (compressedResult) => {
          resolve(
            new File([compressedResult], file.name, {
              type: compressedResult.type,
              lastModified: Date.now(),
            })
          );
        },
        error: reject,
      });
    } else {
      resolve(file);
    }
  });
};

export const fileRejectHandler = (files: any, t: any, maxSize?: number) => {
  files.forEach((file: any) => {
    switch (file.errors[0].code) {
      case 'file-invalid-type':
        return toast.error(t('File type is not valid'));
      case 'file-too-large':
        return toast.error(
          `${t('File is larger then')} ${
            maxSize ? maxSize / MB_TO_BYTE : DEFAULT_MAX_SIZE / MB_TO_BYTE
          }MB`
        );
      default:
        return toast.error(t('Something went wrong with File'));
    }
  });
};
